import CivilMatterView from './CivilMatterView';

export default CivilMatterView;
